import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useStyles } from './styles';
export const Loader = ({ loaderColor }) => {
    const classes = useStyles();
    const blockStyles = { background: loaderColor };
    return (_jsxs("div", { className: classes.loader, children: [_jsx("div", { style: blockStyles }), _jsx("div", { style: blockStyles }), _jsx("div", { style: blockStyles }), _jsx("div", { style: blockStyles }), _jsx("div", { style: blockStyles })] }));
};
